var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnAddCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F9FAFB",
    fillOpacity: 0.996078
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 32.5C44.5 32.7652 44.3946 33.0196 44.2071 33.2071C44.0196 33.3946 43.7652 33.5 43.5 33.5H33.5V43.5C33.5 43.7652 33.3946 44.0196 33.2071 44.2071C33.0196 44.3946 32.7652 44.5 32.5 44.5C32.2348 44.5 31.9804 44.3946 31.7929 44.2071C31.6054 44.0196 31.5 43.7652 31.5 43.5V33.5H21.5C21.2348 33.5 20.9804 33.3946 20.7929 33.2071C20.6054 33.0196 20.5 32.7652 20.5 32.5C20.5 32.2348 20.6054 31.9804 20.7929 31.7929C20.9804 31.6054 21.2348 31.5 21.5 31.5H31.5V21.5C31.5 21.2348 31.6054 20.9804 31.7929 20.7929C31.9804 20.6054 32.2348 20.5 32.5 20.5C32.7652 20.5 33.0196 20.6054 33.2071 20.7929C33.3946 20.9804 33.5 21.2348 33.5 21.5V31.5H43.5C43.7652 31.5 44.0196 31.6054 44.2071 31.7929C44.3946 31.9804 44.5 32.2348 44.5 32.5Z",
    fill: "#1F2124"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DDE0E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnAddCall);
export default __webpack_public_path__ + "static/media/UnAddCall.ce29ed39ca2fa6675de576d479b3dec9.svg";
export { ForwardRef as ReactComponent };